module.exports = __webpack_public_path__ + "static/media/emily-zhang.2b32d4d7.jpg";